import { AttachFile } from '@mui/icons-material';
import { FC } from 'react';
import TaskPrompt from './TaskPrompt';

type Props = {
  label: string;
  onAttachClick: () => void;
};

const FileUploadTaskPrompt: FC<Props> = ({ label, onAttachClick }) => (
  <TaskPrompt
    icon={<AttachFile sx={{ fontSize: 18, color: 'grey.500' }} />}
    label={label}
    primaryAction={{ label: 'Browse files', onClick: onAttachClick }}
  />
);

export default FileUploadTaskPrompt;
